export const MAX_DOCUMENT_DISPLAY_NAME_LENGTH = 255;

export function getDocumentDisplayName(document: {
  name: string;
  display_name?: string | null;
}): string {
  return document.display_name?.trim() || document.name;
}
